module.exports = __webpack_public_path__ + "img/teacherBanner.3d08c4c5.png";